import { IconType } from "assets/icons";
import { DocumentsOperations } from "constant-data/documentsData";

type MenuItemConfig = {
  icon?: IconType;
  name: string;
  collapsed?: boolean;
  children?: Array<MenuItemConfig>;
  path: string;
};

export const MENU_CONFIG: Array<MenuItemConfig> = [
  { icon: "home", name: "Главная", path: "/" },
  {
    icon: "reference",
    name: "Справочники",
    path: "references/",
    children: [
      { name: "Товары", path: "references/products" },
      // { name: "Единицы измерения", path: "references/measure" },
      { name: "Шаблоны для печати", path: "references/print-templates" },
      { name: "Шаблоны чеков", path: "references/cheque-print-templates" },
      { name: "Склады/Магазины", path: "references/stock" },
      { name: "Сотрудники", path: "references/employees" },
      { name: "Клиенты", path: "references/clients" },
      // { name: "Контрагенты", path: "references/agents" },
      // { name: "Кассы/Счета", path: "references/cash-register" },
      { name: "Статьи затрат", path: "references/expenses" },
      { name: "Прайслисты", path: "references/prices" },
      // { name: "Станции", path: "references/stations" },
      // { name: "Причины списания", path: "references/reasons" },
      // { name: "Статусы заказов", path: "references/order-status" },
      // { name: "Шаблоны SMS", path: "references/sms-templates" },
      // { name: "Подарочные сертификаты", path: "references/present-certificates", },
      // { name: "Промокоды", path: "references/promocodes" },
      // { name: "Теги товаров", path: "references/products-tags" },
    ],
  },
  {
    icon: "documents",
    name: "Документы",
    path: "documents/",
    children: DocumentsOperations.filter((i) => i.include).map((i) => ({
      name: i.name,
      path: `documents/${i.id}`,
    })),
  },
  {
    icon: "box",
    name: "Отчёты складские",
    path: "reports",
    children: [
      { name: "Движение товаров", path: "reports/movement" },
      { name: "Отчёт по прибыли", path: "reports/profit" },
      // { name: "Стоимостная оценка", path: "reports/movement" },
      // { name: "Отчёт по списаниям", path: "reports/movement" },
      // { name: "Отчёт по уценке", path: "reports/movement" },
      // { name: "Плановая прибыль", path: "reports/movement" },
      // { name: "Анализ цен", path: "reports/movement" },
      // { name: "Отчёт по закупкам", path: "reports/movement" },
      // { name: "Отчёты финансовые", path: "reports/movement" },
      // { name: "Отчёты по кассе", path: "reports/movement" },
    ],
  },
];
